import classnames from 'classnames';

interface Props {
  align?: string;
  blur?: boolean;
  children: string | string[];
  id?: string;
}

const CardTitle = ({
  align = 'start',
  blur = false,
  children,
  id = undefined,
}: Props) => {
  const className = classnames({
    'text-card-title-color': true,
    'text-2xl': true,
    'mb-1': true,
    'break-all': true,
    'text-start': align === 'start',
    'text-center': align === 'center',
    'text-end': align === 'end',
    'blur-sm': blur,
  });

  return (
    <h4 className={className} id={id}>
      {children}
    </h4>
  );
};

export default CardTitle;
